/**
 *
 */
export class GoodgamePartners {
    public static NETWORK_DEFAULT: number = 1;
    public static NETWORK_GENERAL: number = 1;
    public static NETWORK_FACEBOOK: number = 2;
    public static NETWORK_MYSPACE: number = 3;
    public static NETWORK_STUDIVZ: number = 5;
    public static NETWORK_MEINVZ: number = 5;
    public static NETWORK_SCHUELERVZ: number = 6;
    public static NETWORK_SANDBOXVZ: number = 7;
    public static NETWORK_GENERALVZ: number = 8;
    public static NETWORK_FRIENDSTER: number = 9;
    public static NETWORK_NETLOG: number = 10;
    public static NETWORK_NASZAKLASA: number = 11;
    public static NETWORK_KWICK: number = 12;
    public static NETWORK_LOKALISTEN: number = 13;
    public static NETWORK_MOBAGE: number = 14;
    public static NETWORK_HI5: number = 15;
    public static NETWORK_ORKUT: number = 16;
    public static NETWORK_QUEPASA: number = 17;
    public static NETWORK_SONICO: number = 18;
    public static NETWORK_KIWIBOX: number = 19;
    public static NETWORK_ODNOKLASSNIKI: number = 20;
    public static NETWORK_IWIW: number = 21;
    public static NETWORK_GRONO: number = 22;
    public static NETWORK_YONJA: number = 23;
    public static NETWORK_CHROME: number = 24;
    public static NETWORK_NEUTRON: number = 25;
    public static NETWORK_SPIL_JETZTSPIELEN: number = 26;
    public static NETWORK_LOKALISTEN_SPIELWIESE: number = 27;
    public static NETWORK_SPIL_JEUX_FR: number = 28;
    public static NETWORK_SPIL_GIOCO_IT: number = 29;
    public static NETWORK_SPIL_GRY_PL: number = 30;
    public static NETWORK_SPIL_GIRLSGOGAMES_COM: number = 31;
    public static NETWORK_SPIL_GIRLSGOGAMES_UK: number = 32;
    public static NETWORK_SPIL_SPIELEN: number = 33;
    public static NETWORK_SPIL_AGAME: number = 34;
    public static NETWORK_SPIL_JEU_FR: number = 35;
    public static NETWORK_SPIL_GAMES_UK: number = 36;
    public static NETWORK_SPIL_GAMESGAMES: number = 37;
    public static NETWORK_SPIL_JUEGOS: number = 38;
    public static NETWORK_SPIL_OURGAMES_RU: number = 39;
    public static NETWORK_SPIL_SPELA_SE: number = 40;
    public static NETWORK_SPIL_GIRLSGOGAMES_FR: number = 41;
    public static NETWORK_SPIL_GIRLSGOGAMES_ES: number = 42;
    public static NETWORK_SPIL_JUEGOSDECHICAS: number = 43;
    public static NETWORK_SPIL_GIRLSGOGAMES_RU: number = 44;
    public static NETWORK_SPIL_GIRLSGOGAMES_NL: number = 45;
    public static NETWORK_SPIL_GIRLSGOGAMES_IT: number = 46;
    public static NETWORK_SPIL_GIRLSGOGAMES_SE: number = 47;
    public static NETWORK_SPIL_GIRLSGOGAMES_PL: number = 48;
    public static NETWORK_SPIL_GIRLSGOGAMES_DE: number = 49;
    public static NETWORK_SPIL_GIRLSGOGAMES_BR: number = 50;
    public static NETWORK_SPIL_SPEL_SE: number = 51;
    public static NETWORK_SPIL_FLASHGAMES_RU: number = 52;
    public static NETWORK_SPIL_SPEL_NL: number = 53;
    public static NETWORK_SPIL_ZAPJUEGOS: number = 54;
    public static NETWORK_SPIL_GAME_CO_IN: number = 55;
    public static NETWORK_SPIL_CLICKJOGOS: number = 56;
    public static NETWORK_SPIL_OJOGOS_PT: number = 57;
    public static NETWORK_SPIL_SPELLETJES_NL: number = 58;
    public static NETWORK_SPIL_OJOGOS_BR: number = 59;
    public static NETWORK_SPIL_GUESTS: number = 60;
    public static NETWORK_SPIL_GAMES_CO_ID: number = 61;
    public static NETWORK_SPIL_GIRLSGOGAMES_CO_ID: number = 62;
    public static NETWORK_SPIL_GIOCHI: number = 63;
    public static NETWORK_SPIELAFFE: number = 64;
    public static NETWORK_KRALOYUN: number = 65;
    public static NETWORK_SPIL_HYVES: number = 66;
    public static NETWORK_SPIL_OYUNOYNA: number = 67;
    public static NETWORK_ONE_LT: number = 68;
    public static NETWORK_KANOBU: number = 69;
    public static NETWORK_QIP_RU: number = 70;
    public static NETWORK_DRAUGAS_LT: number = 71;
    public static NETWORK_GOODGAME1: number = 72;
    public static NETWORK_SSO: number = 73;
    public static NETWORK_KONGREGATE: number = 74;
    public static NETWORK_BIG_FISH_GAMES: number = 75;
    public static NETWORK_GAMES_COM: number = 76;

    public static isSpilNetwork(networkId: number): boolean {
        return [
            GoodgamePartners.NETWORK_SPIL_JETZTSPIELEN,
            GoodgamePartners.NETWORK_SPIL_JEUX_FR,
            GoodgamePartners.NETWORK_SPIL_GIOCO_IT,
            GoodgamePartners.NETWORK_SPIL_GRY_PL,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_COM,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_UK,
            GoodgamePartners.NETWORK_SPIL_SPIELEN,
            GoodgamePartners.NETWORK_SPIL_AGAME,
            GoodgamePartners.NETWORK_SPIL_JEU_FR,
            GoodgamePartners.NETWORK_SPIL_GAMES_UK,
            GoodgamePartners.NETWORK_SPIL_GAMESGAMES,
            GoodgamePartners.NETWORK_SPIL_JUEGOS,
            GoodgamePartners.NETWORK_SPIL_OURGAMES_RU,
            GoodgamePartners.NETWORK_SPIL_SPELA_SE,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_FR,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_FR,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_ES,
            GoodgamePartners.NETWORK_SPIL_JUEGOSDECHICAS,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_RU,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_NL,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_IT,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_SE,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_PL,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_DE,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_BR,
            GoodgamePartners.NETWORK_SPIL_SPEL_SE,
            GoodgamePartners.NETWORK_SPIL_FLASHGAMES_RU,
            GoodgamePartners.NETWORK_SPIL_SPEL_NL,
            GoodgamePartners.NETWORK_SPIL_ZAPJUEGOS,
            GoodgamePartners.NETWORK_SPIL_GAME_CO_IN,
            GoodgamePartners.NETWORK_SPIL_CLICKJOGOS,
            GoodgamePartners.NETWORK_SPIL_OJOGOS_PT,
            GoodgamePartners.NETWORK_SPIL_SPELLETJES_NL,
            GoodgamePartners.NETWORK_SPIL_OJOGOS_BR,
            GoodgamePartners.NETWORK_SPIL_GUESTS,
            GoodgamePartners.NETWORK_SPIL_GAMES_CO_ID,
            GoodgamePartners.NETWORK_SPIL_GIRLSGOGAMES_CO_ID,
            GoodgamePartners.NETWORK_SPIL_GIOCHI,
            GoodgamePartners.NETWORK_SPIL_HYVES,
            GoodgamePartners.NETWORK_SPIL_OYUNOYNA
        ].indexOf(networkId) >= 0;
    }

    public static usesCDN(networkId: number): boolean {
        return true;
        /*			return [NETWORK_FACEBOOK,
         NETWORK_MYSPACE,
         NETWORK_FRIENDSTER,
         NETWORK_GENERAL,
         NETWORK_DEFAULT,
         NETWORK_MOBAGE,
         NETWORK_HI5,
         NETWORK_ORKUT,
         NETWORK_QUEPASA,
         NETWORK_SONICO,
         NETWORK_NASZAKLASA].indexOf( networkId ) >= 0;
         */
    }
}
